import { createStore } from 'vuex'

export default createStore({
  state: {
    backgroundImages: {},
    pageSize: 20,
    searchSelected: 'Tots'
  },
  getters: {
    backgroundImage: (state) => (view) => state.backgroundImages[view] || '',
    pageSize: state => state.pageSize,
    searchSelected: state => state.searchSelected
  },
  mutations: {
    /*setBackgroundImage(state, imageUrl) {
      state.backgroundImage = imageUrl;
    },*/
    setBackgroundImage(state, { view, imageUrl }) {
      state.backgroundImages[view] = imageUrl || '';
    },
    setPageSize (state, size) {
      state.pageSize = size
    },
    setSearchSelected(state, option) {
      state.searchSelected = option;
    }
  },
  actions: {
    /*updateBackgroundImage({ commit }, url) {
      commit('setBackgroundImage', url);
    },*/

    updateBackgroundImage({ commit, state }, { view, url }) {

      if (!state.backgroundImages[view]) {
        commit('setBackgroundImage', { view, imageUrl: url });
      }
    },

    updateSearchSelected({ commit }, option) {
      commit('setSearchSelected', option);
    }
  },
  modules: {
  }
})
